import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as BatchActions from "./batch.actions";
import { BatchService } from "../../modules/masters/batch/batch.service";
import { catchError, map, mergeMap, of } from "rxjs";

@Injectable()
export class BatchEffects {
  constructor(
    private actions$: Actions,
    private service: BatchService
  ) {}

  loadBatches$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BatchActions.loadBatches),
      mergeMap(({ itemId }) =>
        this.service.getByItemId(itemId).pipe(
          map((response) => {
            // Handle both array and paginated response formats
            const batches = Array.isArray(response) 
              ? response 
              : (response && typeof response === 'object' && 'data' in response)
              ? response.data
              : [];
            return BatchActions.loadBatchesSuccess({ batches });
          }),
          catchError((err) =>
            of(BatchActions.loadBatchesFailure({ error: err.message }))
          )
        )
      )
    )
  );

  createBatch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BatchActions.createBatch),
      mergeMap(({ batch }) =>
        this.service.create(batch).pipe(
          map((created) => BatchActions.createBatchSuccess({ batch: created })),
          catchError((err) =>
            of(BatchActions.createBatchFailure({ error: err.message }))
          )
        )
      )
    )
  );

  updateBatch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BatchActions.updateBatch),
      mergeMap(({ id, batch }) =>
        this.service.update(id, batch).pipe(
          map((updated) => BatchActions.updateBatchSuccess({ batch: updated })),
          catchError((err) =>
            of(BatchActions.updateBatchFailure({ error: err.message }))
          )
        )
      )
    )
  );

  deleteBatch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BatchActions.deleteBatch),
      mergeMap(({ id }) =>
        this.service.delete(id).pipe(
          map(() => BatchActions.deleteBatchSuccess({ id })),
          catchError((err) =>
            of(BatchActions.deleteBatchFailure({ error: err.message }))
          )
        )
      )
    )
  );

  checkBatchDuplicate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BatchActions.checkBatchDuplicate),
      mergeMap(({ itemId, batchNo, excludeId }) =>
        this.service.checkDuplicate(itemId, batchNo, excludeId).pipe(
          map((res) =>
            BatchActions.checkBatchDuplicateSuccess({ exists: res.exists })
          ),
          catchError((error) =>
            of(
              BatchActions.checkBatchDuplicateFailure({ error: error.message })
            )
          )
        )
      )
    )
  );

  loadAllBatches$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BatchActions.loadAllBatches),
      mergeMap(() =>
        this.service.getAllBatches().pipe(
          map((batches) => BatchActions.loadAllBatchesSuccess({ batches })),
          catchError((error) =>
            of(BatchActions.loadAllBatchesFailure({ error: error.message }))
          )
        )
      )
    )
  );
}

